/* eslint-disable */

import { createRouter, createWebHistory } from "vue-router";
import { Auth } from "@aws-amplify/auth";
import store from "@/store";
import {
  getUserByEmail
}from "@/plugins/authUtils";

const CabinetLogin = () => import("../pages/login/Login");
const CabinetRegister = () => import("../pages/login/Register");

/*import auth from '../app/auth';
import LogoutSuccess from '@/components/LogoutSuccess';
import UserInfoStore from '../app/user-info-store';
import UserInfoApi from '../app/user-info-api';
import ErrorComponent from '@/components/Error';*/

const Default = () => import("../layouts/cabinet/Default");

const NotFound = () => import("../pages/404");

const CabinetConsole = () => import("../pages/cabinet/Console");
const CabinetApplicationsV2 = () => import("../pages/cabinet/ApplicationsV2");
const CabinetAccounts = () => import("../pages/cabinet/Accounts");
const CabinetPlatforms = () => import("../pages/cabinet/Platforms");
const CabinetHistory = () => import("../pages/cabinet/History");
const CabinetDeposit = () => import("../pages/cabinet/Deposit");
const CabinetTransfer = () => import("../pages/cabinet/Transfer");
const CabinetWithdraw = () => import("../pages/cabinet/Withdraw");
const CabinetCalendar = () => import("../pages/cabinet/Calendar");
const CabinetPassword = () => import("../pages/cabinet/Password");
const CabinetLanguage = () => import("../pages/cabinet/Language");
const CabinetEmail = () => import("../pages/cabinet/Email");
const CabinetMFA = () => import("../pages/cabinet/MFA");
const CabinetCalculator = () => import("../pages/cabinet/Calculator");
const CabinetContactUs = () => import("../pages/cabinet/ContactUs");

const ChooseBanks = () => import("../pages/cabinet/ChooseBanks");
const ChooseAlternativeMethods = () => import("../pages/cabinet/ChooseAlternativeMethods");
const AddFunds = () => import("../pages/cabinet/AddFunds");
const AddFundsCreditcar = () => import("../pages/cabinet/AddFundsCreditcar");
const AddBankFunds = () => import("../pages/cabinet/AddBankFunds");
const AddCreditCardFunds = () => import("../pages/cabinet/AddCreditCardFunds");
const SuccessPage = () => import("../pages/cabinet/SuccessPage");
const CancelledPage = () => import("../pages/cabinet/CancelledPage");
const RejectionPage = () => import("../pages/cabinet/RejectionPage");
// const AplicationProcessIndividual 
const AplicationProcess = () => import("../pages/cabinet/AplicationProcess");
const AplicationProcessCorporate = () => import("../pages/cabinet/AplicationProcessCorporate");
const ChooseCreditCard = () => import("../pages/cabinet/ChooseCreditCard");
const NewLiveAccount = () => import("../pages/cabinet/NewLiveAccount");
const NewDemoAccount = () => import("../pages/cabinet/NewDemoAccount");
const AccountActivity = () => import("../pages/cabinet/AccountActivity");
const TradingHistory = () => import("../pages/cabinet/TradingHistory");
const WebTerminalMT4 = () => import("../pages/cabinet/WebTerminalMT4");
const WebTerminalMT5 = () => import("../pages/cabinet/WebTerminalMT5");
const Platforms = () => import("../pages/cabinet/Platforms");

let use_email = ''
async function requireAuth(to, from, next) {
  // console.log('---> requires auth')
  // console.log(store.state.loginEvent)
  await Auth.currentAuthenticatedUser()
    .then((data) => {
      use_email = data.attributes.email
      // console.log(data)
      next();
    })
    .catch((e) => {
      // console.log(e)
      // console.log(from)
      // console.log(to)
      next({
        path: "/login",
        // query: {
        //     redirect: to.fullPath,
        // }
      });
    });
}

/*const change = async ()=>{  
        
      let userInfo = await getUserByEmail(use_email).catch((error) => {
        console.log(error);
      });
      console.log(userInfo)
      let AplicationProcess = ''
      //let act = localStorage.getItem('accountType');
      //console.log(act)
      if(userInfo.accountType == "INDIVIDUAL"){
        console.log(AplicationProcessIndividual)
       return AplicationProcess = AplicationProcessIndividual
      }else if(userInfo.accountType == "CORPORATE"){
        console.log(AplicationProcessCorporate)
        return AplicationProcess = AplicationProcessCorporate
      }
  
}*/

const router = createRouter({
  

  mode: "history",
  base: "/",
  history: createWebHistory(),
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      // redirect: '/cabinet/console/applications'
      redirect: "/login",
    },
    {
      path: "/register",
      redirect: "/register/1/live-account",
    },
    {
      path: "/register/:id/:account",
      name: "Register",
      component: CabinetRegister,
    },
    {
      path: "/login",
      name: "Login",
      component: CabinetLogin,
    },
    {
      path: "/cabinet",
      name: "Cabinet",
      // component: {
      //     name: 'Cabinet',
      //     render(c) {
      //         return c('router-view')
      //     }
      // },
      component: Default,
      children: [
        {
          path: "console",
          name: "Console",
          component: CabinetConsole,
          children: [
            //TODO Redirect applications page to new AplicationProcess component
            /*{
                path: 'applications',
                name: 'Applications',
                component: CabinetApplicationsV2,
                beforeEnter: requireAuth,
            },*/
            {
              path: "accounts",
              name: "Accounts",
              component: CabinetAccounts,
              beforeEnter: requireAuth,
            },
            {
              path: "accounts/:type",
              name: "Accountst",
              component: CabinetAccounts,
              beforeEnter: requireAuth,
            },
            {
              path: "platforms",
              name: "Platforms",
              component: CabinetPlatforms,
              beforeEnter: requireAuth,
            },
            {
              path: "history",
              name: "History",
              component: CabinetHistory,
              beforeEnter: requireAuth,
            },
            {
              path: "deposit",
              name: "Deposit",
              component: CabinetDeposit,
              beforeEnter: requireAuth,
            },
            {
              path: "transfer",
              name: "Transfer",
              component: CabinetTransfer,
              beforeEnter: requireAuth,
            },
            {
              path: "withdraw",
              name: "Withdraw",
              component: CabinetWithdraw,
              beforeEnter: requireAuth,
            },
            {
              path: "calendar",
              name: "Calendar",
              component: CabinetCalendar,
              beforeEnter: requireAuth,
            },
            {
              path: "calculator",
              name: "Calculator",
              component: CabinetCalculator,
              beforeEnter: requireAuth,
            },
            {
              path: "password",
              name: "Password",
              component: CabinetPassword,
              beforeEnter: requireAuth,
            },
            {
              path: "language",
              name: "Language",
              component: CabinetLanguage,
              beforeEnter: requireAuth,
            },
            {
              path: "email",
              name: "Email",
              component: CabinetEmail,
              beforeEnter: requireAuth,
            },
            {
              path: "mfa",
              name: "MFA",
              component: CabinetMFA,
              beforeEnter: requireAuth,
            },
            {
              path: "contact_us",
              name: "Contact Us",
              component: CabinetContactUs,
              beforeEnter: requireAuth,
            },
            {
              path: "choose_banks",
              name: "Choose Banks",
              component: ChooseBanks,
              beforeEnter: requireAuth,
            },
            {
              path: "choose_alternative_methods",
              name: "Choose Alternative Methods",
              component: ChooseAlternativeMethods,
              beforeEnter: requireAuth,
            },
            {
              path: "add_funds/:target",
              name: "Add Funds",
              component: AddFunds,
              beforeEnter: requireAuth,
            },
            {
              path: "add_funds_creditcar/:target",
              name: "Add Creditcar Funds",
              component: AddFundsCreditcar,
              beforeEnter: requireAuth,
            },
            {
              path: "success",
              name: "Success",
              component: SuccessPage,
              beforeEnter: requireAuth,
            },
            {
              path: "cancelled",
              name: "Cancelled",
              component: CancelledPage,
              beforeEnter: requireAuth,
            },
            {
              path: "rejection",
              name: "Rejection",
              component: RejectionPage,
              beforeEnter: requireAuth,
            },
            
            //aplicationprocess
            { //aplicationprocess
              path: "aplicationprocess", //aplicationprocess
              name: "AplicationProcess", //aplicationprocess
              component: AplicationProcess, //aplicationprocess
              beforeEnter: requireAuth, //aplicationprocess
            }, //aplicationprocess
            // add bank funds component
            {
              path: "add_bank_funds/:target",
              name: "Add Bank Funds",
              component: AddBankFunds,
              beforeEnter: requireAuth,
            },
            {
              path: "add_credit_card_funds/:target",
              name: "Add Credit Card Funds",
              component: AddCreditCardFunds,
              beforeEnter: requireAuth,
            },
            {
              path: "choose_credit_card",
              name: "Choose Credit Card",
              component: ChooseCreditCard,
              beforeEnter: requireAuth,
            },
            {
              path: "create_new_live_account",
              name: "New Live Account",
              component: NewLiveAccount,
              beforeEnter: requireAuth,
            },
            {
              path: "create_new_demo_account",
              name: "New Demo Account",
              component: NewDemoAccount,
              beforeEnter: requireAuth,
            },
            {
              path: "account_activity",
              name: "Account Activity",
              component: AccountActivity,
              beforeEnter: requireAuth,
            },
            {
              path: "trading_history",
              name: "Trading History",
              component: TradingHistory,
              beforeEnter: requireAuth,
            },
          ],
        },
        {
          path: "web_terminal_mt4",
          name: "Web Terminal MT4",
          component: WebTerminalMT4,
          beforeEnter: requireAuth,
        },
        {
          path: "web_terminal_mt5",
          name: "Web Terminal MT5",
          component: WebTerminalMT5,
          beforeEnter: requireAuth,
        }
      ],
    },
    // {
    //     path: '/*',
    //     // redirect: '/cabinet/console/applications',
    //     redirect: '/404'
    // },
    {
      path: "/:pathMatch(.*)",
      name: "404",
      // path: '/404',
      component: NotFound,
    },
  ],
}

);

export default router;